import axios from 'axios';
import authHeader from './auth-header';
import moment from "moment"

const API_URL = process.env.VUE_APP_BASE_URL + '/season/';

class SeasonDataService {

    formatDate(date) {
        return moment.utc(date).local().locale('de').calendar();
    }

    createSeason(data) {
        return axios.post(
            API_URL + "create/",
            {
                seasonYear: data.year
            },
            {headers: authHeader()}
        );
    }

    assignDaysToSeason(data) {
        return axios.post(
            API_URL + "assign-days/",
            {
                seasonYear: data.year
            },
            {headers: authHeader()}
        );
    }

    getSeasonDays(data) {
        return axios.post(
            API_URL,
            {
                seasonYear: data.year,
                maintenanceUser: data.maintenanceUser
            },
            {headers: authHeader()}
        );
    }

    getSeasonClassification(subscription) {
        return axios.post(
            API_URL + "classification/",
            {
                subscription: subscription
            },
            {headers: authHeader()}
        );
    }

    getCurrentSeasonYear() {
        return axios.get(
            API_URL + "current-year",
            {headers: authHeader(), timeout: 10000}
        );
    }

    getSeasonMatchDaysDebug() {
        return axios.get(
          API_URL + "debug/matchdays/",
        {headers: authHeader()}
        );
    }

    getSeasons() {
        return axios.get(
            API_URL + "all/",
            {headers: authHeader()}
        );
    }

    getSeasonTeams(data) {
        return axios.post(
            API_URL + "init-teams",
            {
                league: "bl1",
                season: data.year
            },
            {headers: authHeader()}
        );
    }

    getMode(){
        return axios.get(API_URL + "mode", {headers: authHeader()});
    }

    setMode(mode){
        return axios.post(
            API_URL + "mode/set",
            {
                isMaintenance: mode
            },
            {headers: authHeader()}
        );
    }

}

export default new SeasonDataService();